module.exports = __webpack_public_path__ + "media/images/categories/carousel/environment-4bfdcb5508a47661df3c2597e9c9a90a.jpg";